import React, {useState, useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import style from './style.module.css';

import ChapterItem from '../../../parts/ChapterItem/ChapterItem';
import Icons from '../../../parts/Icons/Icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faClose, faBook, faArrowLeft, faArrowRight, faCheck, faX, faStar, faBolt } from '@fortawesome/free-solid-svg-icons';

import { ModuleItem, getUserChaptersData, setCourseView, setMenuOpened, getToken, getUuid, getLanguageArray, Language, 
    setUserPoints, setUserChapters, getUserPoints, setUserLevel, systemLanguage, skipLabel, continueLabel, takeQuizLabel, 
    quizLabel, questionLabel, outOfLabel, completeLabel, videoLabel, nextQuestionLabel, nextChapterLabel, submitLabel, 
    expPointsGainedLabel, expPointsGainedCorrectAnswerLabel, introLabel, setUserActivityData, setUserContData, 
    urlAcademy, getLabel, academyLabel, chapterItemLabel, useMobileView
} from '../../../utils/constants';

import FlowDiagram from '../../../components/FlowDiagram/FlowDiagram';
import Card from '../../../components/Card/Card';

import { getAcademyModule, updateAcademyProgress, setUserQuizAnswer } from '../../../services/academyApi';
import { createActivity } from '../../../services/activityApi';

import { useNotification } from '../../../utils/notifications';
import { chapterLabel } from '../../../utils/helpers';

interface ChapterProps {
    isMenuOpened?: boolean | false
    language: string | 'EN'
}

interface Choice {
  answer: string;
  context: string;
}

interface QuizItem {
  question: { [langCode: string]: string };
  choices: { [langCode: string]: Choice[] };  
  user_answer: number | null;                
  correct: boolean;
}

const Chapter: React.FC<ChapterProps> = ({isMenuOpened, language}) => {

    const { chapter, module, sub } = useParams();
    const notify = useNotification();
    const navigate = useNavigate();

    const isMobile = useMobileView();

    const [menuStatus,setMenuStatus] = useState(false);
    const [filter,setFilter] = useState<boolean|string>(false);
    const [filterLabel,setFilterLabel] = useState<string>('na');

    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    const [completedModules,setCompletedModules] = useState(1)
    const [totalModules,setTotalModules] = useState(7)
    const [completedPercentage,setCompletedPercentage] = useState(12)

    const [loader,setLoader] = useState(false)
    const [intro,setIntro] = useState(true)
    const [video,setVideo] = useState(false)
    const [quizStep,setQuizStep] = useState(false)
    const [quizQuestion,setQuizQuestion] = useState(0)

    const [moduleId,setModuleId] = useState(0)
    const [introText,setIntroText] = useState<Array<string>>([])
    const [videoFile,setVideoFile] = useState(false)
    const [videoFileTypes,setVideoFileTypes] = useState<Array<string>>([])
    const [quiz, setQuiz] = useState<QuizItem[]>([])
    const [title,setTitle] = useState(false)
    const [quizTotal,setQuizTotal] = useState(0)
    const [quizCompleted,setQuizCompleted] = useState(0)
    const [quizCompletePercentage,setQuizCompletePercentage] = useState(0)
    const [userAnswer,setUserAnswer] = useState(-1)
    const [userAnswerStatusCorrect,setUserAnswerStatusCorrect] = useState(false)
    const [userAnswerStatusError,setUserAnswerStatusError] = useState(false)
    const [quizContext,setQuizContext] = useState('')
    const [quizQuestionAnswered,setQuizQuestionAnswered] = useState(true)

    const [nextModule,setNextModule] = useState('')

    const [quizErrors,setQuizErrors] = useState(0)
    const [quizCorrect,setQuizCorrect] = useState(0)

    const [userAnswered,setUserAnswered] = useState(false)

    const lang = JSON.parse(language)

    const userToken = getToken()
    const userUuid = getUuid() 

    const handleChapterFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let value = e.currentTarget.value;
        setFilter(value);
        setFilterLabel(value);
        setMenuStatus(false);
    }

    const handleResetFilter = () => {
        setFilter(false);
    }

    const handleMenu = () => {
        if(menuStatus){
            setMenuStatus(false)
            setCourseView("true")
            setMenuOpened("false")
        }else {
            setMenuStatus(true)
            setCourseView("false")
        }
    }

    const handleGoToStep = async (step:string) => {
        if(step === 'video'){
            let activityLabel = 'intro_'+chapter+'_'+module+'_'+sub+'_read'
            createActivityStream(activityLabel)

            setIntro(false)
            setVideo(true)
            setQuizStep(false)
        }
        if(step === 'quiz')
        {
            if(videoFile)
            {
                let activityLabel = 'video_'+chapter+'_'+module+'_'+sub+'_watched'
                createActivityStream(activityLabel)
            }

            setIntro(false)
            setVideo(false)
            setQuizStep(true)

            const completed = quiz.filter(q => q.user_answer !== null).length;
            const total = quiz.length;
            const correct = quiz.filter(q => q.correct === true).length;
            const wrong = completed - correct;

            const currentQuestion = quiz[quizQuestion];
            const userAnswer = currentQuestion?.user_answer
            const answered = userAnswer !== null
            const userCorrectAnswer = currentQuestion?.correct

            if(answered){
                let context = currentQuestion.choices[lang.short][userAnswer].context
                setQuizContext(context)
                setUserAnswered(answered);
                setQuizCompleted(completed);
                setQuizTotal(total);
                setQuizCorrect(correct);
                setQuizErrors(wrong);
                setUserAnswerStatusCorrect(userCorrectAnswer);
                setQuizCompletePercentage((completed/total*100));
                setUserAnswer(userAnswer)
            }
        }

        setQuizQuestion(0)
    }

    const createActivityStream = async(activityLabel: string, notificationText: string = "Experience Points Gained!", show: boolean = true) => {
            let createActivityReq = await createActivity({
                uuid: userUuid,
                token: userToken,
                user_uuid: userUuid,
                activity_label: activityLabel
            })

            if(createActivityReq.activity)
            {
                setUserActivityData(JSON.stringify(createActivityReq.activity))
                setUserContData(JSON.stringify(createActivityReq.activity_chart))
            }
            
            if(createActivityReq.exp === 0){
                return;
            }

            let userPoints = getUserPoints()
            let newUserPoints = userPoints + createActivityReq.exp
            setUserPoints(newUserPoints)
            setUserLevel(createActivityReq.level)

            if(show){
                notify(
                    <>
                        <FontAwesomeIcon icon={faBolt} /> <span>+{createActivityReq.exp} {notificationText}</span>
                    </>
                )
            }
    }

    const handleCurrentQuizSelected = (id: any) => {
        setUserAnswer(id)
    }

    const handleGoToNextModule = async () => {

        let activityLabel = chapter+'_'+module+'_'+sub+'_completed'
            await createActivityStream(activityLabel, getLabel(expPointsGainedLabel, sessionLang));

        let updateAcademyProgressCall = await updateAcademyProgress({
            uuid: userUuid,
            token: userToken,
            user_uuid: userUuid,
            academy_id: moduleId
        })
        setUserChapters(JSON.stringify(updateAcademyProgressCall.progress))


        setCourseView("false")

        if(!isMobile){
            setMenuStatus(true)
            setMenuOpened("true")
        }
        
        navigate(urlAcademy)
        
    };

    const handleGoToNextQuestion = (id: any) => {

        let activityLabel = 'question_'+chapter+'_'+module+'_'+sub+'_'+id+'_answered'
        createActivityStream(activityLabel, getLabel(expPointsGainedLabel, sessionLang), false)

        const currentQuestion = quiz[id];
        const userAnswer = currentQuestion?.user_answer
        const answered = userAnswer !== null
        const userCorrectAnswer = currentQuestion?.correct

        if(answered){

            const completed = quiz.filter(q => q.user_answer !== null).length;
            const total = quiz.length;
            const correct = quiz.filter(q => q.correct === true).length;
            const wrong = completed - correct;

            let context = currentQuestion.choices[lang.short][userAnswer].context
            setQuizContext(context)
            setUserAnswered(answered);
            setQuizCompleted(completed);
            setQuizTotal(total);
            setQuizCorrect(correct);
            setQuizErrors(wrong);
            setUserAnswerStatusCorrect(userCorrectAnswer);
            setQuizCompletePercentage((completed/total*100));
            setUserAnswer(userAnswer)

        }else {

            setQuizContext('')
            setUserAnswerStatusCorrect(false)
            setUserAnswerStatusError(false)
            setUserAnswered(false)
            setUserAnswer(-1)
            setQuizCompleted(id)
            setQuizCompletePercentage((id/quizTotal)*100)

        }

        setQuizQuestion(id)

    }

    const handleUserQuestionAnswer = async(question: number, answer: number, correct: boolean) => {
        let createUserQuizAnswerReq = await setUserQuizAnswer({
                uuid: userUuid,
                token: userToken,
                user_uuid: userUuid,
                chapter: chapter || "",
                module: module || "",
                sub: sub || "",
                question: question,
                answer: answer,
                correct: correct
            }
        )
    }

    const handleSubmitQuestion = (question: number) => {

        let thisQuestion = (quiz[question] as any)
        let answer = thisQuestion.answer
        let correct = userAnswer === answer

        let context = thisQuestion.choices[lang.short][userAnswer].context
        setQuizContext(context)

        handleUserQuestionAnswer(question,userAnswer,correct)

        if(correct)
        {   
            setUserAnswerStatusCorrect(true)
            setQuizCorrect(quizCorrect+1)
            createActivityStream('question_'+chapter+'_'+module+'_'+sub+'_'+(question+1)+'_answered_correct', getLabel(expPointsGainedCorrectAnswerLabel, sessionLang))
            
        }else {
            setUserAnswerStatusError(true)
            setQuizErrors(quizErrors+1)
            createActivityStream('question_'+chapter+'_'+module+'_'+sub+'_'+(question+1)+'_answered_incorrect')
        }

        setUserAnswered(true)
    }

    useEffect(() => {
        if(!filter)
        {
            setFilterLabel('na');
            return;
        }
    }, [filter])

    useEffect(() => {
        setMenuOpened("false")
        setCourseView("true")
    }, [])

    useEffect(() => {
        if (introText.length === 0) {
          const fetchAcademyModule = async () => {
            try {
              const academyModuleData = await getAcademyModule({
                uuid: userUuid,
                token: userToken,
                chapter: Number(chapter),
                module: Number(module),
                sub: Number(sub),
                user_uuid: userUuid
              });

              const introTextArray = academyModuleData?.intro?.[lang.short] ?? ["Unfortunately, the language you have chosen is not available."];
              setIntroText(introTextArray);

              const titleText = academyModuleData?.title?.[lang.short] ?? "Not Available";
              setTitle(titleText)

              const videoFile = academyModuleData?.video?.file;
              setVideoFile(videoFile)

              const videoTypes = academyModuleData?.video?.types ?? [];
              setVideoFileTypes(videoTypes) 
 
              const quizData = academyModuleData?.quizzes ?? [];
              setQuiz(quizData);
              setQuizTotal(quizData.length)

              setNextModule(academyModuleData.next)
              setModuleId(academyModuleData.id)

            } catch (error) {
              console.error("Failed to fetch academy module data:", error);
            }
          };
      
          fetchAcademyModule();
        }
      }, [introText, userUuid, userToken, chapter, module, sub]);

    useEffect(() => {
            const handler = (e: StorageEvent) => {
                if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
                }
            };
            window.addEventListener("storage", handler);
            return () => window.removeEventListener("storage", handler);
    }, []);


    return (<>
        <div className={`${style.academy} ${!menuStatus? style.closed : ''}`}>
            <div className={`${style.academyMenu} ${!isMenuOpened ? style.menuClosed : ''}`}>
                <div className={style.filter}>
                    <div className={style.label}>Jump To: </div>
                    <select value={filterLabel} onChange={handleChapterFilter} className={`${filter ? style.filtered : ''}`}>
                        <option value="na">{'-- ' + getLabel(chapterItemLabel,sessionLang) + ' --'}</option>
                        {
                            getUserChaptersData().map((item) => {
                                return <option value={item.label}>{chapterLabel(item.chapter,sessionLang)}</option>
                            })
                        }
                    </select>
                    {
                        filter ?
                            <div className={style.close} onClick={handleResetFilter}>
                                <Icons icon={faClose} />
                            </div> : ''
                    }
                </div>
                <div className={style.chapters}>
                    {
                        getUserChaptersData().map((item) => {
                            if(filter && filterLabel !== item.label && filterLabel !== 'na')
                            {
                                return;
                            }
                            return <ChapterItem 
                                        chapter={chapterLabel(item.chapter,sessionLang)}
                                        available={item.available}
                                        description={item.description[lang.short]}
                                        status={item.status as 'in_progress' | 'complete'}
                                        modules={item.modules as ModuleItem[]} 
                                        language={lang.short}
                                />
                        })
                    }
                </div>
            </div><div className={`${style.academyFrame} ${!menuStatus? style.closed : ''}`}>
                    <div className={style.chapterIcon} onClick={handleMenu}>
                        {
                            !menuStatus ? 
                                <><Icons icon={faArrowLeft} /><Icons icon={faBook} /></> : 
                                <Icons icon={faArrowRight} />
                        }
                        
                    </div>
                    <div className={style.chapterWrapper}>
                        <div className={style.chapterContainer}>
                            <div className={`${style.viewWrapperContainer} ${!loader ? style.videoContainer : ''}`}>
                            {
                                loader || !title ? <></> :
                                    intro ? 
                                        <>
                                            <div className={style.introFrame}>
                                                <div className={style.introTitle}>
                                                    <h3>{title}</h3>
                                                </div>
                                                <div className={style.introText}>
                                                    {
                                                        introText.map((line) => {
                                                            return <p>{line}</p>
                                                        })
                                                    }
                                                </div>
                                                <div className={style.buttons}>
                                                    <Link to={"#"} onClick={() => handleGoToStep(!videoFile?'quiz':'video')}>{getLabel(continueLabel, sessionLang)}<span><FontAwesomeIcon icon={faArrowRight} /></span></Link>
                                                </div>
                                            </div>
                                        </> :
                                        video ?
                                            <>
                                            <div className={style.videoFrame}>
                                                    <div className={style.videoPlayer}>
                                                        <video controls>
                                                            {
                                                                videoFileTypes.map((type) => {
                                                                    return <source src={`${process.env.REACT_APP_CDN_URL}/media/video/academy/${sessionLang.short.toLowerCase()}/${videoFile}.${type}`} type={`video/${type}`}></source>
                                                                })
                                                            }
                                                        </video>
                                                    </div>
                                                    <div className={`${style.buttons} ${style.spacer}`}>
                                                        <div className={style.multipleBtn}>
                                                            <Link to={"#"} onClick={() => setIntro(true)}><span><FontAwesomeIcon icon={faArrowLeft} /></span>{title}</Link>
                                                        </div><div className={style.multipleBtn}>
                                                            <Link to={"#"} onClick={() => handleGoToStep('quiz')}>{getLabel(takeQuizLabel, sessionLang)}<span><FontAwesomeIcon icon={faArrowRight} /></span></Link>
                                                        </div>
                                                    </div>
                                            </div>
                                            </> : 

                                            <>
                                            
                                            <div className={style.quizFrame}>
                                                <div className={style.quizHeader}>
                                                    <div className={style.qhLeft}>
                                                        <div className={style.quizTitle}>
                                                            <span><Icons icon={faBook} /></span><span>{title}</span>
                                                        </div><div className={style.quizLabel}>
                                                            {getLabel(quizLabel, sessionLang)}
                                                        </div>
                                                    </div>
                                                    <div className={style.qhRight}>
                                                        <div className={style.qhrIcon}>
                                                            <span><Icons icon={faCheck} /></span><span>{quizCorrect}</span>
                                                        </div><div className={style.qhrError}>
                                                            <span><Icons icon={faX} /></span><span>{quizErrors}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={style.quizProgress}>
                                                    <div className={style.qpLabel}>
                                                        <span>{getLabel(questionLabel, sessionLang)} {quizQuestion+1} {getLabel(outOfLabel, sessionLang)} {quizTotal}</span><span>{quizCompletePercentage}% {getLabel(completeLabel, sessionLang)}</span>
                                                    </div>
                                                    <div className={style.bar}>
                                                        <div
                                                            className={style.completed}
                                                            style={{ width: `${quizCompletePercentage}%` }}
                                                            ></div>
                                                    </div>
                                                </div>

                                                <div className={style.quizQuestion}>
                                                    <div className={style.introTitle}>
                                                        <h3>{
                                                                (quiz[quizQuestion] as any).question?.[lang.short]
                                                            }
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className={style.quizAnswers}>
                                                    {
                                                        Array.isArray((quiz[quizQuestion] as any)?.choices?.[lang.short]) &&
                                                        (quiz[quizQuestion] as any).choices[lang.short].map((item: any, i: number) => (
                                                            <div key={i} className={`${style.answerItem} ${userAnswer === i ? style.selected : ''}`}>
                                                                <input
                                                                    type="radio"
                                                                    name="quiz-option"
                                                                    value={i}
                                                                    onChange={() => setUserAnswer(i)}
                                                                    checked={userAnswer === i ? true : false}
                                                                /><span>{item.answer}</span>
                                                            </div>
                                                        ))
                                                    }
                                                    {
                                                        userAnswered ?
                                                            <>
                                                                <div className={`${style.context} ${userAnswerStatusCorrect ? style.correct : style.error}`}>
                                                                    <div className={style.emoji}>
                                                                        {
                                                                            userAnswerStatusCorrect ? '😁' : '😔'
                                                                        }
                                                                    </div>
                                                                    <div className={style.text}>
                                                                        {quizContext}
                                                                    </div>
                                                                </div>
                                                            </> : ''
                                                    }
                                                    {
                                                        userAnswer !== -1 && !userAnswered ?
                                                            <>
                                                                <div className={style.submit}>
                                                                    <span onClick={() => handleSubmitQuestion(quizQuestion)}>{getLabel(submitLabel, sessionLang)}</span>
                                                                </div>
                                                            </> : ''
                                                    }
                                                </div>
                                            </div>
                                            <div className={`${style.buttons} ${style.spacer}`}>
                                                <div className={style.multipleBtn}>
                                                    <Link to={"#"} onClick={() => !videoFile ? setIntro(true) : handleGoToStep('video')}><span><FontAwesomeIcon icon={faArrowLeft} /></span>{
                                                        !videoFile ? 
                                                            getLabel(introLabel, sessionLang) :
                                                            getLabel(videoLabel, sessionLang)
                                                    }</Link>
                                                </div><div className={style.multipleBtn}>
                                                    {
                                                        userAnswered ? 
                                                            quizQuestion+1 === quizTotal ?
                                                                <Link to={"#"} onClick={handleGoToNextModule}>{getLabel(academyLabel, sessionLang)}<span><FontAwesomeIcon icon={faArrowRight} /></span></Link> :
                                                                <Link to={"#"} onClick={() => handleGoToNextQuestion(quizQuestion+1)}>{getLabel(nextQuestionLabel, sessionLang)}<span><FontAwesomeIcon icon={faArrowRight} /></span></Link> 
                                                            
                                                        : '' 
                                                    }
                                                </div>
                                            </div>
                                        </>
                            }
                            </div>
                        </div>
                    </div>        
            </div>
        </div>
    </>)
}

export default Chapter;
